import { Component } from 'react';
import { CloudinaryContext, Image, Transformation } from 'cloudinary-react';
import Imgix from "react-imgix";
import { isImgixUrl, logCloudinaryUrlDetected } from "../../utils/cloudinary/cloudinaryUtils";

interface CdnImageProps
{
    // Config values from getConfig() are typed as string | number | boolean.
    cloudName?: string | number | boolean;
    publicId?: string | number | boolean;
    width?: number | string;
    height?: number | string;
    grayScale?: boolean;
    crop?: string;
    fit?: string;
    [key: string]: unknown;
}

class CdnImage extends Component<CdnImageProps>
{
    render()
    {
        var grayScaleTransformation = null;
        if (this.props.grayScale)
            grayScaleTransformation = <Transformation effect="grayscale" />

        const publicId = this.props.publicId;
        const cloudName = this.props.cloudName;

        if (isImgixUrl(publicId))
        {
            return <div style={{ textAlign: 'center' }}>
                <Imgix src={publicId}
                    {...this.props}
                    imgixParams={{
                        q: 100,
                        w: this.props.width,
                        h: this.props.height,
                        crop: this.props.crop ? this.props.crop : "focalpoint",
                        fit: this.props.fit ? this.props.fit : "crop",
                        grayscale: this.props.grayScale ? 1 : 0
                    }}
                    alt="Image"
                />
            </div>
        }

        if (typeof publicId === 'string' && publicId.length > 0)
        {
            logCloudinaryUrlDetected(publicId, {
                cloudName,
                source: "CdnImage",
            });
        }

        return (<CloudinaryContext cloudName={cloudName}>
                    <div style={{ textAlign: 'center' }}>
                        <Image
                            publicId={publicId}
                            width={this.props.width}
                            height={this.props.height}
                            crop="fill"
                            gravity="center"
                            quality="auto"
                        >
                            {grayScaleTransformation}
                        </Image>
                    </div>
                </CloudinaryContext>);
    }
}

export default CdnImage;
